import $ from "jquery";
import PermissionsTemplatesMenu from "../../../administration/userManagement/permissionsTemplates/PermissionsTemplatesMenu";
import CreatePermissionsTemplateView from "./CreatePermissionsTemplateView";
import EditPermissionsTemplateView from "./EditPermissionsTemplateView";
import AnimateDialogWrapper from '../../../util/AnimatedDialogWrapper'
import messageResource from "../../../messageResource"
import makeRpcCall from "../../../util/jquery_rpc";
import _ from "underscore";
import {setEventPreventHidingEditUserSlidingPanel} from '../../../panels/utils'

export default class PermissionsTemplatesButtonController {
    constructor({$containerEl,
        $button,
        withoutChoosing = false,
        onChangeDialogVisibility = (visible) => {},
        onChangeTemplates = () => {},
        additionalClassName = '',
    }) {

        this.$containerEl = $containerEl;
        this.$permissionTemplatesMenuButton = $button
        this.state = {
            templates: [],
            editUserIsLoggedIn: false,
            editedTemplateId: null,
            isURAEnabled: false,
            isBTYEnabled: false,
            isPTOEnabled: false,
            isSDBEnabled: false,
            isLTTEnabled: false,
        }
        this.withoutChoosing = withoutChoosing;
        this.onChangeDialogVisibility = onChangeDialogVisibility
        this.onChangeTemplates = onChangeTemplates
        this.additionalClassName = additionalClassName

        this._handleSaveNewTemplate = this._handleSaveNewTemplate.bind(this)
        this._handleResetTemplateChanges = this._handleResetTemplateChanges.bind(this)
        this._handleSaveEditTemplate = this._handleSaveEditTemplate.bind(this)
        this._preventHideForEditedTemplate = this._preventHideForEditedTemplate.bind(this)
        this._preventHideForNewTemplate = this._preventHideForNewTemplate.bind(this)
    }

    init() {
        if (!this.$permissionTemplatesMenuButton) {
            this.$permissionTemplatesMenuButton = $(
                "<div class='templatesButton'>" +
                "   <div class='icon'/><div class='applyTemplate'>"
                + messageResource.getMessage("userlist.userdata.permissions_templates.apply_template") + "</div>" +
                "</div>");
            this.$containerEl.append(this.$permissionTemplatesMenuButton);
        }

        this.createTemplateView = new CreatePermissionsTemplateView(this.$containerEl, {
            withoutChoosing: this.withoutChoosing,
            onSaveButtonClick: this._handleSaveNewTemplate,
            onCloseButtonClick: () => this.createTemplateDialogWrapper.hide(),
        })
        this.createTemplateDialogWrapper = new AnimateDialogWrapper(
            this.$containerEl,
            {
                dialog: this.createTemplateView,
                className: 'user_permissionsTemplatesDialog ' + this.additionalClassName,
                keyFrameClass: 'anim-user-permissions-dialog',
                preventHide: this._preventHideForNewTemplate,
                onHide: () => {this.onChangeDialogVisibility(false)}
            }
        ).init()

        this.editTemplateView = new EditPermissionsTemplateView(this.$containerEl, {
            withoutChoosing: this.withoutChoosing,
            onSaveButtonClick: this._handleSaveEditTemplate,
            onResetButtonClick: this._handleResetTemplateChanges,
            onCloseButtonClick: () => this.editTemplateDialogWrapper.hide(),
        })
        this.editTemplateDialogWrapper = new AnimateDialogWrapper(
            this.$containerEl,
            {
                dialog: this.editTemplateView,
                className: 'user_permissionsTemplatesDialog ' + this.additionalClassName,
                keyFrameClass: 'anim-user-permissions-dialog',
                preventHide: this._preventHideForEditedTemplate,
                onHide: () => {this.onChangeDialogVisibility(false)}
            }
        ).init()

        return this;
    }

    createAndInitPermissionTemplatesMenu(permissionsTemplates) {
        this.permissionTemplatesMenu = new PermissionsTemplatesMenu().init({
            menuId: "permissionTemplatesMenuId",
            templatesData: permissionsTemplates,
            onCreateTemplateCallback: this._handleCreateTemplate,
            onEditTemplateCallback: this._handleEditTemplate,
            onSelectTemplateCallback: (templateData) => $(this).trigger('applyTemplate', [templateData.permissions, this.state.editUserIsLoggedIn]),
            onDeleteCallback: (data) => this.setState({templates: data}),
            canShowMenu: () => true,
            onClickDialogContent: (e) => setEventPreventHidingEditUserSlidingPanel(e),
        })

        const showMenuCallback = () => {
            this.permissionTemplatesMenu.showAt(this.$containerEl, this.$permissionTemplatesMenuButton, {left: -80});
            this.permissionTemplatesMenu.getMenuElement().addClass('rightAlignedArrow');
        };
        this.$permissionTemplatesMenuButton.off("click").on("click", showMenuCallback);
    }

    setState(newState) {
        let prevState = {...this.state}
        this.state = {...this.state, ...newState};
        if (!this.permissionTemplatesMenu)
            this.createAndInitPermissionTemplatesMenu(this.state.templates);
        else
            this.permissionTemplatesMenu.updateTemplatesData(this.state.templates);

        if (prevState.isURAEnabled !== this.state.isURAEnabled
            || prevState.isBTYEnabled !== this.state.isBTYEnabled
            || prevState.isPTOEnabled !== this.state.isPTOEnabled
            || prevState.isSDBEnabled !== this.state.isSDBEnabled
            || prevState.isLTTEnabled !== this.state.isLTTEnabled) {
            this.editTemplateView.setState({
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled,
                isPTOEnabled: this.state.isPTOEnabled,
                isSDBEnabled: this.state.isSDBEnabled,
                isLTTEnabled: this.state.isLTTEnabled,
            })
            this.createTemplateView.setState({
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled,
                isPTOEnabled: this.state.isPTOEnabled,
                isSDBEnabled: this.state.isSDBEnabled,
                isLTTEnabled: this.state.isLTTEnabled,
            })
        }
    }

    _handleSaveEditTemplate = (data) => {

        this._saveAndApplyButtonCallback(
            this.editTemplateDialogWrapper,
            {
                ...data,
                id: this.state.editedTemplateId
            },
            "PermissionsTemplatesService.updateTemplate",
            ['id', 'name', 'permissions']
        )
        this.permissionTemplatesMenu.hide()
    }

    _handleSaveNewTemplate = (data) => {
        this._saveAndApplyButtonCallback(
            this.createTemplateDialogWrapper,
            data,
            "PermissionsTemplatesService.createTemplate",
            ['name', 'permissions']
        )
        this.permissionTemplatesMenu.hide()
    }

    _handleResetTemplateChanges = () => {
        const editedTemplate = this.state.templates.find(({id}) => id === this.state.editedTemplateId)
        this.editTemplateView.setState({
            ...editedTemplate
        })
    }

    _handleEditTemplate = (templateData) => {
        this.state.editedTemplateId = templateData.id
        this.editTemplateDialogWrapper.setState({
            ...templateData,
            duplicateName: false,
            emptyName: false
        });
        this.editTemplateDialogWrapper.showAt(this.$permissionTemplatesMenuButton)
        this.onChangeDialogVisibility(true)
    }

    _handleCreateTemplate = () => {
        this.state.editedTemplateId = null
        this.createTemplateDialogWrapper.setState({
            name: '',
            permissions: [],
            duplicateName: false,
            emptyName: false
        });
        this.createTemplateDialogWrapper.showAt(this.$permissionTemplatesMenuButton);
        this.onChangeDialogVisibility(true)
    }

    _preventHideForNewTemplate = () => {
        const dataChanged = !this._areTemplateDataEqual(
            {name: '', permissions: []},
            this.createTemplateView.getTemplateData()
        )

        return dataChanged && !this._confirmCloseDialog()
    }

    _preventHideForEditedTemplate = () => {
        const dataChanged = !this._areTemplateDataEqual(
            this.state.templates.find(({id}) => id === this.state.editedTemplateId),
            this.editTemplateView.getTemplateData()
        )

        return dataChanged && !this._confirmCloseDialog()
    }

    _confirmCloseDialog = () => {
        return confirm(messageResource.getMessage('userlist.userdata.permissions_templates.discard_changes_confirmation'))
    }

    _areTemplateDataEqual = (data, anotherData) => {
        return data.name === anotherData.name && _.isEqual(data.permissions, anotherData.permissions)
    }

    _saveAndApplyButtonCallback = (dialogWrapper, data, methodName, paramKeys) => {
        const self = this;
        const params = Object.values(_.pick(data, paramKeys));

        if (data.name === '' || data.name === null) {
            dialogWrapper.setState({
                emptyName: true
            })
            return
        }

        if (this.state.templates.find(({name, id}) => id !== data.id && name === data.name)) {
            dialogWrapper.setState({
                duplicateName: true
            })
            return
        }

        dialogWrapper.setState({
            dataUpdating: true,
        });

        this.rpcCall = makeRpcCall(methodName, params,
            function(templates) {
                self.setState({templates});
                dialogWrapper.setState({dataUpdating: false});
                self.onChangeTemplates({templates, permissions: data.permissions, userLoggedIn: self.state.editUserIsLoggedIn})
                dialogWrapper.hide(true);
            },
            function(jqXHR, textStatus, errorThrown) {
                if (textStatus === "abort") {
                    return true;
                }
                dialogWrapper.setState({dataUpdating: false});

                if (errorThrown.exception === 'com.actimind.actitime.services.PermissionsTemplateDuplicateNameException') {
                    dialogWrapper.setState({duplicateName: true});
                    self.setState({templates: errorThrown.templates});
                    return true;
                }
                if (errorThrown.exception === 'com.actimind.actitime.services.PermissionsTemplateNotExistException') {
                    self.setState({templates: errorThrown.templates});
                    if (confirm(messageResource.getMessage('userlist.userdata.permissions_templates.js.no_such_template_confirmation'))) {
                        self._saveAndApplyButtonCallback(dialogWrapper, "PermissionsTemplatesService.createTemplate", data, ['name', 'permissions']);
                    }
                    else {
                        dialogWrapper.hide();
                    }
                    return true;
                }
                if (errorThrown.exception === 'com.actimind.actitime.services.NoRightsToManageAccountSettings') {
                    alert(messageResource.getMessage("userlist.js.error_cant_manage_user_account"));
                    document.location.reload();
                    return true;
                }
            });
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/permissionsTemplates/PermissionsTemplatesButtonController.js